import React from 'react';
import { Body, Title } from '../Typography/index.js';
export const ConfirmationDialog = ({ actions, prompt, title }) => {
    return (React.createElement("div", { className: "tw-w-full tw-h-full tw-flex" },
        React.createElement("div", { className: "tw-m-auto tw-flex tw-flex-col tw-space-y-4" },
            React.createElement(Title, { level: 3, size: "md", addClassName: "tw-flex tw-justify-center" }, title),
            React.createElement(Body, { size: "md" }, prompt),
            React.createElement("div", { className: "tw-flex tw-flex-row tw-space-x-2 tw-justify-center" }, actions))));
};
//# sourceMappingURL=ConfirmationDialog.js.map